var exports = {
  "kL": "x61f99309--5687fc--container",
  "AS": "x61f99309--5687fc--item",
  "Sl": "x61f99309--5687fc--image",
  "x6": "x61f99309--5687fc--button",
};

module.exports = exports;
